import { render, staticRenderFns } from "./SpecificationTravel.vue?vue&type=template&id=4fe328e6"
import script from "./SpecificationTravel.vue?vue&type=script&lang=js"
export * from "./SpecificationTravel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports